/** @format **/
import React, { FunctionComponent } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import EditButton from '../../components/Buttons/EditButton';
import I18n from '../../components/Translate/I18n';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import MvnoOperationSetup from '../../interfaces/platform/MvnoOperatorSetup';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';

const useStyle = makeStyles(adescomStyle);

type ServiceProfileItemType = {
    item: MvnoOperationSetup;
    setActiveRow: (id: number) => void;
    activeRow: number;
    viewCallback: (iri: { uri: string }, event: any) => void;
    deleteCallback: (iri: { uri: string }, event: any) => void;
};

export const ServiceProfileItem: FunctionComponent<ServiceProfileItemType> = ({
    item,
    activeRow,
    setActiveRow,
    viewCallback,
    deleteCallback,
}): React.ReactElement => {
    const classes = useStyle();

    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRootBordered };
    const tableRowRoot = { root: classes.tableRowRoot };

    let rowActiveColor = 'white';
    if (activeRow === item.id) {
        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
    }

    return (
        <TableRow
            classes={tableRowRoot}
            key={'key' + item.id}
            hover
            onClick={(): void => {
                setActiveRow(item.id);
            }}
            style={{ backgroundColor: rowActiveColor }}
        >
            <TableCell classes={tableControlStickyHeader} padding="none" align="left" style={{ backgroundColor: rowActiveColor }}>
                {UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TEMPLATE_UPDATE) && (
                    <EditButton
                        callback={viewCallback}
                        callbackParam={{ uri: item['@id'] }}
                        tooltipTitle="prov:profile.edit_profile"
                        tooltipPlacement="bottom-start"
                    />
                )}
                {/*{UserRoleHelper.checkRole(roles.ROLE_SIM_CARD_SERVICE_TEMPLATE_DELETE) && (*/}
                {/*    <DeleteButton*/}
                {/*        callback={deleteCallback}*/}
                {/*        callbackParam={{ uri: item['@id'] }}*/}
                {/*        tooltipTitle="prov:features.delete_template"*/}
                {/*        tooltipPlacement="bottom-start"*/}
                {/*    />*/}
                {/*)}*/}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.constName}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.displayName}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="center">
                {item.prepaid && <I18n trans="general:common.yes" />}
                {!item.prepaid && <I18n trans="general:common.no" />}
            </TableCell>
        </TableRow>
    );
};
